<template>
  <div id="questionnaire-page">
    <iframe
      v-show="isShow"
      id="innerPage"
      :src="outPath"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import {
  wxConfigFn,
  GetQueryString,
  GetQueryStringUrl
} from '../../utils/utils'
export default {
  data() {
    return {
      outPath: '',
      isAnswer: false,
      isShow: false
    }
  },
  components: {},
  methods: {
    // 设置分享
    async setShare(shareData) {
      console.log(shareData)
      if (!shareData) {
        return
      }
      let shareDataEnCodeUrl = encodeURIComponent(shareData.questionnaireUrl)
      let shareuserId = JSON.parse(window.localStorage.getItem('userInfo')).id
      let basePath = process.env.VUE_APP_BaseURL
      console.log(
        '分享地址',
        `${basePath}/questionnaire?shareuserId=${shareuserId}&outPath=${shareDataEnCodeUrl}`
      )
      wx.ready(function() {
        //需在用户可能点击分享按钮前就先调用
        wx.updateAppMessageShareData({
          title: '答问卷，领酬金！', // 分享标题
          desc: `${shareData.title}，${shareData.unitPrice}元`, // 分享描述
          link: `${basePath}/questionnaire?shareuserId=${shareuserId}&outPath=${shareDataEnCodeUrl}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl:
            'https://pfg-1.oss-cn-shenzhen.aliyuncs.com/static/img/wjhb.jpeg', // 分享图标
          success: function() {
            // 设置成功
            console.log('设置成功1')
          }
        })
        wx.ready(function() {
          //需在用户可能点击分享按钮前就先调用
          wx.updateTimelineShareData({
            title: '答问卷，领酬金！', // 分享标题
            link: `${basePath}/questionnaire?shareuserId=${shareuserId}&outPath=${shareDataEnCodeUrl}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl:
              'https://pfg-1.oss-cn-shenzhen.aliyuncs.com/static/img/wjhb.jpeg', // 分享图标
            success: function() {
              // 设置成功
              console.log('设置成功2')
            }
          })
        })
      })
    },
    getAnswerState() {},
  },
  async created() {
    let outPath = GetQueryString('outPath')
    console.log('outPath+' + outPath)
    let url = window.location.href
    if (window.wechaturl !== undefined) {
      // 兼容ios 生成签名的当前页面地址取值 ios url地址为入口地址
      url = window.wechaturl
    }

    // 配置微信jsdk
    wxConfigFn(url, ['updateAppMessageShareData', 'updateTimelineShareData'])

    let quesId = GetQueryStringUrl('UserInfo1', decodeURIComponent(outPath))
    console.log('quesId--'+quesId)
    console.log('de--outPath--'+decodeURIComponent(outPath))
    let params = {
      id: quesId
    }

    // 获取是否答过此问卷
    let isAnswer = await $api.getAnswerState(params)
    // 获取此问卷的信息
    let shareData = await $api.getQuestionnaire(params)
    // 保存项目类型，用于结束页的下一份问卷的请求
    window.sessionStorage.setItem('queType', shareData.questionnaireType)
    if (!isAnswer) {
      this.isShow = !isAnswer
      // 获取用户id
      let userId = JSON.parse(window.localStorage.getItem('userInfo')).id
      let shareuserId = GetQueryString('shareuserId')
      // 如果存在shareuserId，则是分享路径进来
      if (shareuserId) {
        this.outPath = `${decodeURIComponent(
          outPath
        )}&UserInfo2=${userId}&UserInfo3=${shareuserId}`
      } else {
        // 则用户自己进来
        this.outPath = `${decodeURIComponent(outPath)}&UserInfo2=${userId}`
      }
      // 设置分享
      this.setShare(shareData)
    } else {
      this.$router.push({
        path: '/endPage',
        query: {
          isAnswer: true,
          type: shareData.questionnaireType
        }
      })
    }
    
  },
  mounted() {
    // this.$nextTick(()=>{
    //   let iframe = document.getElementById("innerPage")
    //   let contentWindow = iframe.contentWindow
    //     console.log(iframe,'iframe1')
    //     console.log(contentWindow,'iframe2')
    //     console.log(contentWindow.document.body,'iframe3')
    //     contentWindow.document.body.addEventListener('click',function(){
    //       console.log('监听到iframe里面发生了点击')
    //     })
    // })
  }
}
</script>
<style lang='less'>
#questionnaire-page {
  width: 100%;
  height: calc(100vh - 40px);
  //overflow: hidden;
  #innerPage {
    width: 100%;
    height: 100%;
  }
}
</style>
